import { inAppText } from '../../../../constants/inAppText';
import { getValidationObject } from '../../../../constants/regexPatterns';

export const fieldNames = {
  contractNumber: 'contract_number',
  description: 'description',
  contactEmail: 'contact_email',
  contactCc: 'contact_cc'
};

export const requirementFormStack = [
  {
    name: fieldNames.contractNumber,
    label: 'Record Number',
    placeholder: '#12345',
    required: false,
    validation: { ...getValidationObject('alphaNumericAndCharacters') }
  },
  {
    name: fieldNames.contactEmail,
    label: 'Record Contact Emails',
    placeholder: 'contact1@email.com, contact2@email.com',
    required: false,
    validation: {
      maxLength: { value: 500, message: 'Record contact emails must have fewer than 500 characters' },
      ...getValidationObject('commaSeparatedEmailAddress')
    },
    tooltip: inAppText.tooltips.projectDetails.requirementInformation.requirementContact
  },
  {
    name: fieldNames.description,
    label: 'Record Description',
    placeholder: 'Description text here...',
    required: false,
    validation: {},
    type: 'textArea'
  }
];
